module.exports = __webpack_public_path__ + "assets/img/complaint_state_4.f32f4b5c.svg";